module.exports = __webpack_public_path__ + "KabelBdNormal.woff2?f56055149fa9745709f76ca1118f5f6d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/KabelBdNormal.woff2
// module id = 46
// module chunks = 0